import { Link } from "react-router-dom";

interface MovieCardProps {
  id: number;
  title: string;
  genre: string;
  rating: number;
  poster: string;
  updateInfo: string;
  isNew?: boolean;
  isHot?: boolean;
}

export default function MovieCard({ id, title, genre, rating, poster, updateInfo, isNew, isHot }: MovieCardProps) {
  return (
    <Link
      to={`/article/${id}`}
      className="group block cursor-pointer no-underline"
    >
      <div className="relative aspect-[3/4] rounded-lg overflow-hidden bg-background-200">
        <img
          src={poster}
          alt={title}
          className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />

        <div className="absolute top-2 left-2 flex gap-1.5">
          {isNew && (
            <span className="px-1.5 py-0.5 text-[10px] font-bold rounded bg-primary-500 text-white whitespace-nowrap">
              NEW
            </span>
          )}
          {isHot && (
            <span className="px-1.5 py-0.5 text-[10px] font-bold rounded bg-accent-500 text-background-950 whitespace-nowrap">
              热播
            </span>
          )}
        </div>

        <div className="absolute top-2 right-2">
          <span className="px-1.5 py-0.5 text-[10px] font-semibold rounded bg-background-950/70 text-accent-400 whitespace-nowrap">
            {rating}
          </span>
        </div>

        <div className="absolute bottom-2 right-2 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
          <span className="px-2 py-1 text-[10px] rounded bg-primary-500 text-white whitespace-nowrap">
            立即观看
          </span>
        </div>
      </div>

      <div className="mt-2.5 px-0.5">
        <h3 className="text-sm font-medium text-foreground-950 line-clamp-1 group-hover:text-primary-500 transition-colors">
          {title}
        </h3>
        <div className="flex items-center justify-between mt-1">
          <span className="text-xs text-foreground-500">{genre}</span>
          <span className="text-xs text-foreground-400">{updateInfo}</span>
        </div>
      </div>
    </Link>
  );
}